import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { isNumeric, findDataField } from './utils.js';
import styled from 'styled-components';
import { MoreInputFields } from './moreinputs'

const SmallSpan = styled.span`
font-size: 70%;
`

let enable_submit

function logit(mesg)
{
    console.log('message from selenium: %O', mesg)
}

function ContactInputField({frmid, stepId})
{
    const [step, setStep] = useState(null),
	  [iti, setIti] = useState(null),
	  [values, setValues] = useState({
	      name: '',
	      extra: '',
	      phone: '',
	      countryCode: '',
	      email: '',
	      preferredContactMethod: '',
	      phoneConsented: false,
	      smsConsented: false,
	      emailConsented: false
	  }),
	  [moreValidated, setMoreValidated] = useState(false),
	  validateEmail = (email) => {
	      return String(email)
		  .toLowerCase()
		  .match(
		      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		  );
	  }
    useEffect(() => {
	enable_submit(false)
	if ( frmid && stepId ) {
	    fetch(`/pub/form/${frmid}/${stepId}/`)
		.then(r => r.ok ? r.json() : Promise.reject(r))
		.then(json => {
		    setStep(json)
		    setMoreValidated(!('moreInputs' in json && json.moreInputs && json.moreInputs.length > 0))
		    enable_submit(!json.valueRequired)
		})
		.catch(r => {
		    console.error('error in operation: %O, %O', r.status, r.statusText)
		    r.text().then(text => console.error('detail: %O', text))
		})
	}
    }, [frmid, stepId])
    useEffect(() => {
	if ( ! step ) return
	const geoFunc = step.restrictTo.length > 0 ? null : function(success, failure) {
	    fetch('/ipcountry/')
		.then(r => r.ok ? r.json() : Promise.reject(r))
		.then(json => {
		    success(json.country)
		})
		.catch(r => failure())
	}
	const input = document.getElementById(findDataField(step.dataFields, 'phone').id)
	setIti(window.giti = window.intlTelInput(input, {
	    utilsScript: "/assets/intl-tel-input/js/utils.js",
	    separateDialCode: true,
	    strictMode: true,
	    onlyCountries: step.restrictTo,
	    initialCountry: step.restrictTo && step.restrictTo.length == 1 ? step.restrictTo[0] : 'us',
	    geoIpLookup: geoFunc
	}));
	input.addEventListener('keyup', ev => {
	    setValues(prev => ({...prev, phone: ev.target.value}))
	})
	enable_submit(!step.valueRequired)
    }, [step])
    useEffect(() => {
	if ( iti ) {
	    const countryData = iti.getSelectedCountryData()
	    setValues(prev => ({...prev, countryCode: countryData.dialCode}))
	}
    }, [values.phone])
    useEffect(() => {
	if ( ! step ) return
	enable_submit(false)
	console.log('values = %O', values)
	if ( ! values.preferredContactMethod ) {
	    return
	}
	if ( step.nameRequired && !values.name ) {
	    return
	}
	if ( 'extraRequired' in step && step.extraRequired !== 'none' && !values.extra ) {
	    return
	}
	if ( step.requiredMethod === 'email' ||
	     step.requiredMethod === 'both' ||
	     values.preferredContactMethod === 'email' ) {
	    if ( ! values.email ) {
		return
	    } else if ( !validateEmail(values.email) ) {
		return
	    }
	}
	if ( step.requiredMethod === 'phone' ||
	     step.requiredMethod === 'both' ||
	     values.preferredContactMethod === 'phone' ||
	     values.preferredContactMethod === 'sms' ) {
	    if ( ! values.phone ) {
		return
	    } else if ( ! iti.isValidNumber() ) {
		return
	    }
	}
	if ( !(values.email || values.phone) ) {
	    return
	}
	if ( values.email && !validateEmail(values.email) ) {
	    return
	}
	if ( values.phone && !iti.isValidNumber() ) {
	    return
	}
	enable_submit(moreValidated)
    }, [values, moreValidated])
    return step ? (
	<>
	    <input type="hidden"
		   name={findDataField(step.dataFields, 'phone').id}
		   id={"id-" + findDataField(step.dataFields, 'phone').id}
		   value={"+" + values.countryCode + '-' + values.phone}/>
	    {step.nameRequired && (
		<div class="mb-3">
		    <label class="form-label tertiary-text">{step.nameLabel}</label>
		    <input type="text"
			   class="form-control"
			   id={"id-" + findDataField(step.dataFields, 'name').id}
			   name={findDataField(step.dataFields, 'name').id}
			   value={values.name}
			   onChange={ev => setValues(prev => ({...values, name: ev.target.value}))}/>
		</div>
	    )}
	    {step.extraRequired !== 'none' && step.extraLabel && (
		<div class="mb-3">
		    <label class="form-label tertiary-text">{step.extraLabel}</label>
		    <input type="text"
			   class="form-control"
			   id={"id-" + findDataField(step.dataFields, step.extraRequired).id}
			   name={findDataField(step.dataFields, step.extraRequired).id}
			   value={values.extra}
			   onChange={ev => setValues(prev => ({...prev, extra: ev.target.value}))}/>
		</div>
	    )}
	    <div class="mb-3">
		<label class="form-label tertiary-text">
		    <span class="me-2">{step.phoneLabel}</span>
		    {(step.requiredMethod === 'phone' ||
		      step.requiredMethod === 'both' ||
		      values.preferredContactMethod === 'phone' ||
		      values.preferredContactMethod === 'sms' ) && (
			  <SmallSpan>(required)</SmallSpan>
		      )}
		</label>
		<input type="text"
		       class="form-control"
		       id={findDataField(step.dataFields, 'phone').id}/>
		{step.phoneConsentRequired && (
		    <div class="form-check d-flex"
			 style={{gap: '10px', placeItems: 'center'}}>
			<input class="form-check-input"
			       type="checkbox"
			       id="phoneConsentCheckbox"
			       name={findDataField(step.dataFields, 'phone-consent').id}
			       checked={values.phoneConsented}
			       onChange={ev => setValues(prev => ({...prev, phoneConsented: ev.target.checked}))}/>
			<label class="form-check-label tertiary-text" for="phoneConsentCheckbox">
			    {step.phoneConsentText}
			</label>
		    </div>
		)}
		{step.smsConsentRequired && (
		    <div class="form-check d-flex"
			 style={{gap: '10px', placeItems: 'center'}}>
			<input class="form-check-input"
			       type="checkbox"
			       id="smsConsentCheckbox"
			       name={findDataField(step.dataFields, 'sms-consent').id}
			       checked={values.smsConsented}
			       onChange={ev => setValues(prev => ({...prev, smsConsented: ev.target.checked}))}/>
			<label class="form-check-label tertiary-text" for="smsConsentCheckbox">
			    {step.smsConsentText}
			</label>
		    </div>
		)}
	    </div>
	    <div class="mb-3">
		<label class="form-label tertiary-text">
		    <span class="me-2">{step.emailLabel}</span>
		    {(step.requiredMethod === 'email' ||
		      step.requiredMethod === 'both' ||
		      values.preferredContactMethod === 'email') && (
			  <SmallSpan>(required)</SmallSpan>
		      )}
		</label>
		<input type="email"
		       class="form-control"
		       id={"id-" + findDataField(step.dataFields, 'email').id}
		       name={findDataField(step.dataFields, 'email').id}
		       value={values.email}
		       onChange={ev => setValues(prev => ({...prev, email: ev.target.value}))}/>
		{step.emailConsentRequired && (
		    <div class="form-check d-flex"
			 style={{gap: '10px', placeItems: 'center'}}>
			<input class="form-check-input"
			       type="checkbox"
			       id="emailConsentCheckbox"
			       name={findDataField(step.dataFields, 'email-consent').id}
			       checked={values.emailConsented}
			       onChange={ev => setValues(prev => ({...prev, emailConsented: ev.target.checked}))}/>
			<label class="form-check-label tertiary-text" for="emailConsentCheckbox">
			    {step.emailConsentText}
			</label>
		    </div>
		)}
	    </div>
	    <div class="mb-3">
		<label class="form-label tertiary-text">
		    <span class="me-2">Preferred contact method</span>
		    <SmallSpan>(required)</SmallSpan>
		</label>
		<div class="form-check">
		    <input class="form-check-input"
			   type="radio"
			   value="email"
			   name={findDataField(step.dataFields, 'email').id}
			   id="preferredContactMethodEmail"
			   checked={values.preferredContactMethod === 'email'}
			   onChange={ev => setValues(prev => ({...prev, preferredContactMethod: ev.target.value}))}/>
		    <label class="form-check-label tertiary-text" for="preferredContactMethodEmail">
			Email
		    </label>
		</div>
		<div class="form-check">
		    <input class="form-check-input"
			   type="radio"
			   value="phone"
			   name={findDataField(step.dataFields, 'phone').id}
			   id="preferredContactMethodPhone"
			   checked={values.preferredContactMethod === 'phone'}
			   onChange={ev => setValues(prev => ({...prev, preferredContactMethod: ev.target.value}))}/>
		    <label class="form-check-label tertiary-text" for="preferredContactMethodPhone">
			Phone
		    </label>
		</div>
		<div class="form-check">
		    <input class="form-check-input"
			   type="radio"
			   value="sms"
			   name={findDataField(step.dataFields, 'sms').id}
			   id="preferredContactMethodSMS"
			   checked={values.preferredContactMethod === 'sms'}
			   onChange={ev => setValues(prev => ({...prev, preferredContactMethod: ev.target.value}))}/>
		    <label class="form-check-label tertiary-text" for="preferredContactMethodSMS">
			SMS
		    </label>
		</div>
	    </div>
	    <MoreInputFields step={step} setValidated={setMoreValidated}/>
	</>
    ) : <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>
}

(function() {
    const rootId = document.currentScript.getAttribute('data-rootid'),
	  el = document.getElementById(rootId),
	  stepId = el.getAttribute('data-stepid'),
	  frmid = el.getAttribute('data-frmid')
    enable_submit = (enable) => {
	if ( 'enable_submit' in window ) window.enable_submit(stepId, enable)
    }
    createRoot(el).render(<ContactInputField frmid={el.getAttribute('data-frmid')}
					     stepId={stepId}/>);
})();
